import { StyledInfoBlock } from '@/components/styles'

export default function InfoBlock({ title, desc, children }) {
  return (
    <StyledInfoBlock>
      <StyledInfoBlock.Title>{title}</StyledInfoBlock.Title>
      <StyledInfoBlock.Desc>{desc}</StyledInfoBlock.Desc>
      {children}
    </StyledInfoBlock>
  )
}
